module.exports = __webpack_public_path__ + "static/img/sm12.3b50aaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm12.png
// module id = khq7
// module chunks = 1